export default __webpack_public_path__ + "static/media/donut_small_active.38f5ecc5.svg";